export default {
  dismissed: true,
  dismissedAt: true,
  // Transient state - not persisted
  isOpen: false,
  isLoading: false,
  isError: false,
  hasData: false,
  errorMessage: false,
};
